export default __webpack_public_path__ + "static/media/menu.b4d32123.svg";